import React, { FC } from 'react';
import { Button, ButtonProps } from '@clearcover/atlas';

import { useAppContext } from 'QuoteApp/services/providers';
import { isPresent } from 'Shared/utils';
import styles from './styles.module.css';
import { Rate } from './Rate';
import { RewardPointsEstimate } from './RewardPointsEstimate';

type FooterProps = {
  nextButton?: React.ReactElement;
  previousButton?: React.ReactElement;
  hideRate?: boolean;
  showRewardsEarned?: boolean;
  disclaimer?: React.ReactElement;
};

export const FooterPreviousButton: FC<ButtonProps> = ({
  children,
  ...buttonProps
}) => (
  <Button
    data-testid="footer-previous-button"
    type="button"
    size="lg"
    variant="secondary"
    className={styles.previousButton}
    {...buttonProps}
  >
    {children}
  </Button>
);

export const FooterNextButton: FC<ButtonProps> = ({
  children,
  disabled,
  ...buttonProps
}) => (
  <Button
    data-testid="footer-next-button"
    type="button"
    size="lg"
    className={styles.nextButton}
    variant="primary"
    disabled={disabled}
    {...buttonProps}
  >
    {children}
  </Button>
);

export const Footer: FC<FooterProps> = ({
  nextButton,
  previousButton,
  hideRate,
  showRewardsEarned,
  disclaimer,
}) => {
  const { rewardsEnrollmentResponse } = useAppContext();

  return (
    <>
      <div className={styles.footerContainer}>
        <div className={styles.content}>
          <div className={styles.left}>
            {isPresent(previousButton) && previousButton}
          </div>
          <div className={styles.center}>{!hideRate && <Rate />}</div>
          <div className={styles.right}>
            <div className={styles.pointEstimateMeter}>
              {rewardsEnrollmentResponse?.isEnrolled && showRewardsEarned && (
                <RewardPointsEstimate />
              )}
            </div>
            {isPresent(nextButton) && nextButton}
          </div>
        </div>
      </div>
      {!!disclaimer && (
        <div className={styles.disclaimerContainer}>{disclaimer}</div>
      )}
    </>
  );
};
